import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonHttpService } from '../commonHttp.service';
import { LoaderService } from '../../_shared/services/loader.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-store-user-login',
  templateUrl: './store-user-login.component.html',
  styleUrls: ['./store-user-login.component.css']
})
export class StoreUserLoginComponent implements OnInit {

  responseMessage: any = '';
  constructor(private service: CommonHttpService, private router: Router, private route: ActivatedRoute, private loaderService: LoaderService) { }
  user : any = {}
	baseUrl: any = environment.apiUrl;
  
  ngOnInit() {
  }

  login(){
  	console.log(this.user);
  	this.loaderService.display(true);
    
    this.service.create(this.baseUrl + 'UserAPI/StoreUserLogin', this.user)
      .subscribe(
        data => {
          console.log(data)
          if(data.statusCode == 1){
          	localStorage.setItem('storeUserId', data.storeUserId);
          	localStorage.setItem('customerName', data.customerName);
            localStorage.setItem('isLoggedin', 'true');
            localStorage.setItem('isStoreUser', 'true');
            
            //this.router.navigate(['/Dashboard']);
            window.location.href = './StoreUser';
          }
          else{
          	this.responseMessage = data.responseMessage;
          }
          this.loaderService.display(false);
        },
        (error) => {
          this.loaderService.display(false);
        })
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/store-user-login/store-user-login.component.ts